<template>
  <div v-if="visible" ref="confirm" class="cp-confirm mobile">
    <div class="box-mask">
      <div class="box-container">
        <div class="box-content">
          您绑定的角色为<span class="emphsis">{{text}}</span>,绑定后将无法更换,确认绑定该角色吗?
        </div>
        <div class="button">
          <div class="bottom-item confirm" @click="handleAction('yes')"></div>
          <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
        </div>
        <Close is-mobile @close="handleAction('cancel')" class="close"></Close>
      </div>
    </div>
  </div>
</template>

<script>
import Close from '~/components/Close/close.vue';
// import { mapState } from "vuex";
export default {
  name: 'Confirm',
  components: {Close},
  data() {
    return {
      visible: false,
      text: '',
      promiseStatus: null
    }
  },
  methods: {
    confirm() {
      let _this = this;
      this.visible = true;
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      this.$refs.confirm.className += ' fadeOut';
      let t = setTimeout(() => {
        this.visible = false;
        clearTimeout(t);
        if (action === 'yes') {
          this.promiseStatus && this.promiseStatus.resolve('ok');
        } else {
          this.promiseStatus && this.promiseStatus.reject('cancel');
        }
      }, 300);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-confirm{
    text-align: center;
    color: #2c3e50;
    height: 100%;
    font-size: .32rem;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index 2001
    top 0
    animation fadeIn 0.3s ease-in-out
    &.fadeOut {
      animation fadeOut 0.3s ease-in-out
      animation-fill-mode forwards
    }
    .box-mask{
      z-index: 900;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .box-container {
    position absolute
    width 6.66rem
    height 5.16rem
    top 50%
    left 0.42rem
    margin-top -2.58rem
    background-image url('./images/alert.png')
    background-size: 6.66rem 4.46rem;
    background-repeat: no-repeat;
    background-position 0 0
    animation fadeIn 0.3s ease-in-out
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 1rem;
    .box-header {
      padding-top: 0.25rem;
    }
    .box-title {
      text-align: center;
      padding-left: 0;
      margin-bottom: 0;
      font-size: 0.32rem;
      font-weight: 700;
      color: #333;
      letter-spacing 0.04rem
    }
    .box-content{
      word-break: break-all;
      line-height: 0.5rem;
      font-size 0.3rem;
      color: #000;
      font-weight bold;
      width: 79%;
      margin: 0 auto;
      .emphsis {
        color: #b42d00
      }
    }
    .button {
      width 5.05rem
      height 0.89rem
      margin: 0.46rem auto 0
      .bottom-item {
        width 2.32rem
        height 0.86rem
        background-image url('./images/confirm.png')
        background-size: 100% 100%
        background-repeat: no-repeat;
        display inline-block
        &.cancel {
          width 2.34rem
          height 0.89rem
          margin-left 0.39rem
          background-image url('./images/cancel.png')
        }
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
